import initKycMFEApiService from 'components/KycMFE/initKycMFEApiService';
import initBillingsMFEApiService from 'components/BillingsMFE/initBillingsMFEApiService';
import initDatabasesMFEApiService from '../../components/DatabasesMFE/initDatabasesMFEApiService';
import initRdiMFEApiService from '../../components/RdiMFE/initRdiMFEApiService';
import initSubscriptionsMFEApiService from '../../screens/SubscriptionsAndDatabases/Subscriptions/SubscriptionsMFE/initSubscriptionsMFEApiService';
import initLangCacheMFEApiService from '../../components/LangcacheUIMFE/initLangCacheMFEApiService';
import initContextEngineMFEApiService from '../../components/ContextEngineUIMFE/initContextEngineMFEApiService';

const initMfesApiServices = () => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  Promise.all([
    initDatabasesMFEApiService(),
    initRdiMFEApiService(),
    initSubscriptionsMFEApiService(),
    initLangCacheMFEApiService(),
    initContextEngineMFEApiService(),
    initKycMFEApiService(),
    initBillingsMFEApiService()
  ]);
};

export default initMfesApiServices;
